import * as React from 'react';
import { createComponent } from '@lit/react';
import type { EventName } from '@lit/react';
import { Checkbox as SpCheckbox } from '@spectrum-web-components/checkbox';

import '@spectrum-web-components/checkbox/sp-checkbox.js';

export const Checkbox = createComponent({
    displayName: 'Checkbox',
    elementClass: SpCheckbox,
    react: React,
    tagName: 'sp-checkbox',
    events: {
        change: 'change' as EventName<Event>, // Announces a change in the `checked` property of a Checkbox
    },
});

export type CheckboxType = EventTarget & SpCheckbox;
